module.exports = __webpack_public_path__ + "img/suigomi.3a221c5d.jpg";